
















































































import { State, Action, Getter } from 'vuex-class';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { OptionType } from '@/enums/OptionType';
import { Locale } from '@/enums/Locale';

@Component({
  components: {
    PagePresetDashboard: () => import('@/layouts/presets/dashboard.vue'),
    PartBox: () => import('@/layouts/parts/box.vue'),
    PartOverlay: () => import('@/layouts/parts/overlay.vue'),
    // Form elements
    FormBase: () => import('@/components/forms/Base.vue'),
    FormInput: () => import('@/components/forms/Input.vue'),
    FormButton: () => import('@/components/forms/Button.vue'),
    ServerError: () => import('@/components/forms/ServerError.vue'),
    LanguageSelector: () => import('@/components/parts/LanguageSelector.vue'),
  },
})
export default class PageOptionsShow extends Vue {
  i18n: string = 'views.options.show';

  @Getter('option/viewing') option?: Option;

  @Getter('workspace/selected') workspace!: Workspace;

  @Action('option/create') createOption!: ({ data, workspaceId }: { data: OptionCreateData; workspaceId: number }) => Promise<Option>;

  @Action('option/update') updateOption!: ({ id, data, workspaceId }: { id: number; data: OptionUpdateData; workspaceId: number }) => Promise<Option>;

  @Action('option/delete') deleteOption!: (payload: { id: number; workspaceId: number }) => Promise<Option>;

  @Action('option-translation/index') indexOptionTranslations!: (payload: { query?: IndexQuery<OptionTranslation>; workspaceId: number }) => Promise<{ data: OptionTranslation[]; total: number }>;

  @Action('option-translation/create') createOptionTranslation!: ({ data, workspaceId }: { data: OptionTranslationData; workspaceId: number }) => Promise<OptionTranslation>;

  @Action('option-translation/update') updateOptionTranslation!: ({ id, data, workspaceId }: { id: number; data: OptionTranslationData; workspaceId: number }) => Promise<OptionTranslation>;

  $refs!: Vue['$refs'] & {
    optionForm: FormClass;
    deleteForm: FormClass;
  };

  formLoaded: boolean = false;

  payload: OptionCreateData = {
    key: '',
    name: '',
    type: OptionType.STRING,
    template: null,
    filterable: true,
    ordinal: 0,
  };

  translationPayload: OptionTranslationData = {
    option_id: 0,
    name: '',
    locale: Locale.NL_BE,
  };

  popupDeleteOption: boolean = false;

  selectedLanguage: Locale = process.env.VUE_APP_DEFAULT_LOCALE;

  optionTranslationId?: number;

  get typeOptions() {
    return Object.values(OptionType);
  }

  get defaultLanguageSelected() {
    return process.env.VUE_APP_DEFAULT_LOCALE === this.selectedLanguage;
  }

  get inputName(): string {
    if (this.defaultLanguageSelected) {
      return this.payload.name;
    }
    return this.translationPayload.name;
  }

  set inputName(name: string) {
    if (this.defaultLanguageSelected) {
      this.payload.name = name;
    }
    this.translationPayload.name = name;
  }

  get submitFunction() {
    if (this.defaultLanguageSelected) {
      return this.handleSubmit;
    }
    return this.handleTranslationSubmit;
  }

  handleSubmit() {
    let func: string = 'updateOption';
    if (!this.option?.id) {
      func = 'createOption';
    }

    // @ts-ignore
    this[func]({ id: this.option?.id, data: this.payload, workspaceId: this.workspace.id })
      .then((option: Option) => {
        this.$refs.optionForm.handleSuccess();
        if (func === 'createOption' && option.id) {
          this.$router.push({ name: 'options-detail', params: { id: `${option.id}` } });
        }
      })
      .catch((e: ErrorResponse) => this.$refs.optionForm.handleErrors(e));
  }

  handleTranslationSubmit() {
    if (this.optionTranslationId === undefined) {
      this.createOptionTranslation({ data: this.translationPayload, workspaceId: this.workspace.id })
        .then((productTranslation) => {
          this.optionTranslationId = productTranslation.id;
          this.$refs.optionForm.handleSuccess();
        })
        .catch((e: ErrorResponse) => this.$refs.optionForm.handleErrors(e));
      return;
    }
    this.updateOptionTranslation({ id: this.optionTranslationId, data: this.translationPayload, workspaceId: this.workspace.id })
      .then(() => {
        this.$refs.optionForm.handleSuccess();
      })
      .catch((e: ErrorResponse) => this.$refs.optionForm.handleErrors(e));
  }

  handleDelete() {
    if (this.option?.id) {
      this.deleteOption({ id: this.option.id, workspaceId: this.workspace.id })
        .then(() => {
          this.popupDeleteOption = false;
          this.$refs.deleteForm.handleSuccess();
          this.$router.push({ name: 'options' });
        })
        .catch((e: ErrorResponse) => this.$refs.deleteForm.handleErrors(e));
    }
  }

  async handleLanguageChange(language: Locale) {
    this.selectedLanguage = language;

    if (this.defaultLanguageSelected) {
      return;
    }

    const translation = await this.indexOptionTranslations({
      query: {
        q: {
          and: {
            option_id: this.option!.id,
            locale: this.selectedLanguage,
          },
        },
        per_page: 1,
      },
      workspaceId: this.workspace.id,
    });

    this.optionTranslationId = translation?.data[0]?.id;
    this.translationPayload = { name: translation?.data[0]?.name ?? this.payload.name, locale: language, option_id: this.option!.id! };
  }

  @Watch('option', { immediate: true, deep: true })
  handleOptionChanged(val: Option) {
    if (!val) {
      return undefined;
    }

    // @ts-ignore
    this.payload = structuredClone(val);
  }

  @Watch('workspace')
  workspaceChanged(val: Workspace) {
    this.$router.push({ name: 'options' });
  }
}
